import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import "./User.css";
import { API } from "aws-amplify";


export default class User extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    this.state = {
      isLoading: null,
      exaUserId: '',
      name: '',
      email: '',
      accountId: '',
      account: '',
      user: {},
    };
  }

  async componentDidMount() {
  
    try {
      const user = await this.getUser();
      if (user) {
        this.setState({ 
          exaUserId: user.ExaUserId,
          name: user.NameFull ? user.NameFull : '',
          email: user.EmailAddress,
          accountId: user.AccountId ? user.AccountId : '',
          account: user.AccountName ? user.AccountName : '',
        });
      }
      // if (!this.state.email) {
      //   const cognitoUser = await Auth.currentAuthenticatedUser();
      //   // const userInfo = JSON.parse(cognitoUser)
      //   console.log('userInfo', cognitoUser)
      //   this.setState({ email: cognitoUser.attributes.email})
      // }

    } catch (e) {
      alert(e);
    }
    this.setState({ isLoading: false });
  }

  getUser() {
    return API.get("users", "/users");
  }


  validateForm() {
    let isValid = false;
    if (this.state.name.length > 0 && this.state.account.length > 0 ) {
      isValid = true;
    }
    return isValid;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      await this.updateUser({
        EmailAddress: this.state.email,
        NameFull: this.state.name,
        AccountId: this.state.accountId,
        AccountName: this.state.account,
      });
      // this.props.history.push("/");
      this.setState({ isLoading: false });
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }
  
  updateUser(user) {
    return API.put("users", "/users", {
      body: user,
    });
  }

  render() {
    return (
      <div className="user">
      <h3>User Information</h3>
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="exaUserId">
            <FormControl.Static>
              <p>{this.state.email}</p>
              {this.state.exaUserId}
            </FormControl.Static>
          </FormGroup>
          <FormGroup controlId="name">
            <ControlLabel>Full Name</ControlLabel>
            <FormControl
              onChange={this.handleChange}
              value={this.state.name}
              componentClass="input"
            />
          </FormGroup>
          <FormGroup controlId="account">
            <ControlLabel>Account Name</ControlLabel>
            <FormControl
              onChange={this.handleChange}
              value={this.state.account}
              componentClass="input"
            />
          </FormGroup>
          <FormGroup controlId="accountId">
            <ControlLabel>AccountId</ControlLabel>
            <FormControl
              onChange={this.handleChange}
              value={this.state.accountId}
              componentClass="input"
            />
          </FormGroup>
          <LoaderButton
            bsStyle="primary"
            bsSize="large"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Update"
            loadingText="Updating..."
          />
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/settings/User.js